export default "__VITE_ASSET__9Zqvq1zI__"